
export const menuItems = [
    {
      title: "Dashboard",
      path: "/",
      icon: "fas fa-tachometer-alt",
    },
    {
      title: "Schools",
      icon: "fas fa-school",
      secureCode: "ADMIN-VIEW",
      subMenu: [
        { title: "Register School", path: "/schools/add" },
        { title: "View Schools", path: "/schools/view" },
      ],
    },
    {
      title: "Students",
        icon: "fas fa-user-graduate",
      subMenu: [
        { title: "Register Student", path: "/students/search" },
        { title: "View Students", path: "/students" },
        { title: "Transfer Student", path: "/students/transfer"},
        
      ],
    },
    {
      title: "Contacts",
        icon: "fas fa-phone",
      path: "/contacts",
    },
    // {
    //   title: "Student Groups",
    //   icon: "fas fa-users",
    //   path: "/class-groups",
    //   secureCode: "SCHOOL-USER-VIEW",
    // },
    {
      title: "Call Logs",
      icon: "fas fa-phone-volume",
      path: "/call-logs",
      secureCode: "SCHOOL-USER-VIEW",
    },
    {
      title: "Cards / Wristbands",
        icon: "fas fa-id-card",
      subMenu: [
        { title: "Assigned Students", path: "/school-buzz-cards" },
        { title: "Pending Students", path: "/pending-school-buzz-cards" },
        
      ],
      secureCode: "SCHOOL-USER-VIEW",
    },
    
    {
      title: "Call Logs",
      icon: "fas fa-phone-volume",
      path: "/call-logs",
      secureCode: "ADMIN-VIEW",
    },
    {
      title: "Calling Stations",
      icon: "fas fa-mobile-alt",
      path: "/stations",
    },
    {
      title: "Cards / Wristbands",
        icon: "fas fa-id-card",
      subMenu: [
        { title: "All Cards & Wristbands", path: "/buzz-cards" },
        { title: "Pending Attachments", path: "/pending-buzz-cards" },
        
      ],
      secureCode: "ADMIN-VIEW",
    },
    
    {
      title: "Statistics",
      icon: "fas fa-chart-pie",
      secureCode: "ADMIN-VIEW",
      subMenu: [
        { title: "Account Activations", path: "/account-activations" },
        { title: "Termly Fees", path: "/termly-fees"},
        { title: "Replacements / Swaps", path: "/card-replacements" },
        { title: "Dormant Accounts", path: "/dormant-accounts" },
        { title: "Message Statistics", path: "/message-stats" },
        


      ],
    },
    {
      title: "Reports",
      icon: "fas fa-folder-open",
      secureCode: "ADMIN-VIEW",
      subMenu: [
        { title: "Pocket Money Balances", path: "/pocket-money-balances" },
        { title: "Credit Balances (Students)", path: "/credit-balances" },
        { title: "Credit Balances (Parents)", path: "/credit-balances/parents" },
        { title: "Float Balances (Vendors)", path: "/vendor-balances" },
        { title: "Commission Balances", path: "/vendor-commissions" },
        
      ],
    },
    
    // {
    //   title: "Reports",
    //   icon: "fas fa-folder-open",
    //   secureCode: "SCHOOL-USER-VIEW",
    //   subMenu: [
    //     { title: "Dormant Accounts", path: "/dormant-accounts" }
        
    //   ],
    // },
    {
      title: "Transactions",
      icon: "fas fa-money-check-alt",
      secureCode: "ADMIN-VIEW",
      subMenu: [
        { title: "Mobile Money", path: "/mm/list" },
        { title: "Pocket Money", path: "/pocket-money/list" },
        { title: "MM Charges", path: "/mm-charges/list" },
        { title: "POS Deposit Charges", path: "/deposit-charges/list" },
        { title: "Transaction Categories", path: "/buzztime-charges/list" },

      ],
    },
    {
      title: "System Users",
        icon: "fas fa-users",
      secureCode: "ADMIN-VIEW",
      subMenu: [
        { title: "Vendors", path: "/vendors" },
        { title: "School Admins", path: "/school_admin/view" },
        { title: "System Admins", path: "/admin/view" },
      ],
    },
  ];
  